// extracted by mini-css-extract-plugin
export var reset = "styles-module--reset--2OADH";
export var loader = "styles-module--loader--1E0d4";
export var hideContent = "styles-module--hideContent--3ylNV";